import { flowMax, addProps } from 'ad-hok'
import { addApi, addConfig } from 'shared/src/api'
import {
  addPathParam,
  redirectTo404IfNullish,
} from 'shared/src/utils/addNavigate'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { makeResources, ResourceName } from '../components/resource'

export const addResource = flowMax(
  addPathParam('resourceName'),
  addApi,
  addConfig,
  addTranslationHelpers,
  addProps(({ api, config, resourceName, t }) => ({
    resource: makeResources(api, config, t)[resourceName as ResourceName],
  })),
  redirectTo404IfNullish('resource')
)
